import { useToast } from "@/hooks/use-toast";
import { Card } from "@/components/ui/card";
import { Loader2, Copy } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useServiceNumber } from "../hooks/useServiceNumber";

interface TaxReturnReferenceProps {
  taxReturnId: string;
}

export function TaxReturnReference({ taxReturnId }: TaxReturnReferenceProps) {
  const { serviceNumber, isLoading } = useServiceNumber(taxReturnId);
  const { toast } = useToast();

  const copyToClipboard = async () => {
    if (serviceNumber) {
      try {
        await navigator.clipboard.writeText(serviceNumber);
        toast({
          title: "Copied!",
          description: "Reference number copied to clipboard",
        });
      } catch (err) {
        toast({
          title: "Failed to copy",
          description: "Please try copying manually",
          variant: "destructive",
        });
      }
    }
  };

  return (
    <Card className="p-4">
      <div className="space-y-1">
        <p className="text-sm font-medium text-muted-foreground">
          Tax Return Reference
        </p>
        <div className="flex items-center justify-between">
          <p className="text-lg font-semibold font-mono">
            {isLoading ? (
              <span className="flex items-center gap-2">
                <Loader2 className="h-4 w-4 animate-spin" />
                Generating reference...
              </span>
            ) : serviceNumber ? (
              serviceNumber
            ) : (
              "No reference available"
            )}
          </p>
          {serviceNumber && (
            <Button
              variant="ghost"
              size="icon"
              onClick={copyToClipboard}
              className="ml-2"
            >
              <Copy className="h-4 w-4" />
            </Button>
          )}
        </div>
      </div>
    </Card>
  );
}